import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Homemade Bath Soaks </h1>

    
    <div className="imgs max800">
        <div>
            <img src={require('../assets/craft/bathSalts/inBox.jpeg')} data-skip-gallery/>
        </div>
    </div>

    <p>I made these bath soaks to give to my sister as my gift for her 
    bridal shower in 2019. I purchased dried flowers such as lavender, rose, and marigold to put in these 
    mixed bath soaks, and created the bath salts by mixing epsom salt with sea salt. In 
    addition to the salts and flowers, I sprinkled in some rose and lavender essential 
    oils to add a nice fragrance, and pink and purple food coloring to match the 
    respective flowers.</p>

    <p>The final gift box:</p>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/craft/bathSalts/finalGift.jpg')} data-skip-gallery/>
        </div>
    </div>

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.